export const MENU_ITEMS_SOURCES = ['dmProductGroups'] as const;
export type MenuItemsSource = (typeof MENU_ITEMS_SOURCES)[number];

export type NavigationNode = {
    id: string;
    /** System name of the navigation node */
    key: string;
    /** 0-based index among siblings */
    index: number;
    /** Path of navigation node, root node is '/Home' */
    path: string;
    /** Localized name of the navigation node */
    name: string;
    route: string | null;
    parent: NavigationNode;
    /** menuProperties object brick field */
    menuProperties: {
        // GlobalMenuItem brick
        // Wether this node should be displayed in global menu
        isGlobalMenuItem: boolean;
        additionalMenuItemsSource: MenuItemsSource | null;
    };
};
